import { render, staticRenderFns } from "./VehicleTypeModal.vue?vue&type=template&id=1bb10f4e"
import script from "./VehicleTypeModal.vue?vue&type=script&lang=js"
export * from "./VehicleTypeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports